import { Doctor, Specialty } from '../../../domain/entities';
import { FirebaseDoctor } from '../entities';

export class DoctorMapper {
  static toDomain(firebaseDoctor: FirebaseDoctor, specialty: Specialty) {
    const availableDays = this.mapNumberDaysToDates(firebaseDoctor.availableDays);

    return new Doctor({
      id: firebaseDoctor.id!,
      name: firebaseDoctor.name,
      medicalCenter: firebaseDoctor.medicalCenter,
      specialty,
      availableDays
    });
  }

  static toFirebaseEntity(doctor: Doctor): FirebaseDoctor {
    return {
      name: doctor.name,
      medicalCenter: doctor.medicalCenter,
      specialtyCode: doctor.specialty.code,
      availableDays: []
    };
  }

  private static mapNumberDaysToDates(dayNumberArray: number[]): Date[] {
    const today = new Date();
    const weeksInTheFuture = 2;
    const firstDayOfThisWeek = new Date(today.setDate(today.getDate() - today.getDay()));

    const availableDates: Date[] = [];
    dayNumberArray.forEach((dayNumber) => {
      for (let i = 0; i <= weeksInTheFuture; i++) {
        const tempDate = new Date(firstDayOfThisWeek.getTime());
        availableDates.push(new Date(tempDate.setDate(tempDate.getDate() + dayNumber + i * 7)));
      }
    });

    return availableDates;
  }
}
